import React from 'react';

import styles from './Infographic.module.scss';

const {
  infographic: infographicStyle,
  pointer: pointerClass,
  'img-circle': imgCircleStyle
} = styles;

const Infographic = ({ infoCopy, imgUrl }) => {
  return (
    <div className={infographicStyle}>
      <div className={pointerClass} />
      <img src={imgUrl} alt="" className={imgCircleStyle} />
      <p>{infoCopy}</p>
    </div>
  );
};

export default Infographic;
